// ===== MODAL STORE =====

import { create } from 'zustand';

interface ModalState {
  // Modal visibility states
  isContactModalOpen: boolean;
  isLoadingScreenVisible: boolean;
  
  // Modal actions
  openContactModal: () => void;
  closeContactModal: () => void;
  setLoadingScreen: (visible: boolean) => void;
  
  // Utility actions
  closeAllModals: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  // Initial state
  isContactModalOpen: false,
  isLoadingScreenVisible: true,
  
  // Modal actions
  openContactModal: () => set({ isContactModalOpen: true }),
  closeContactModal: () => set({ isContactModalOpen: false }),
  setLoadingScreen: (visible) => set({ isLoadingScreenVisible: visible }),
  
  // Utility actions
  closeAllModals: () => set({ 
    isContactModalOpen: false,
    isLoadingScreenVisible: false 
  }),
}));

// ===== SELECTOR HOOKS =====

// Contact modal selectors - using individual selectors to avoid object creation
export const useContactModal = () => {
  const isOpen = useModalStore((state) => state.isContactModalOpen);
  const open = useModalStore((state) => state.openContactModal);
  const close = useModalStore((state) => state.closeContactModal);
  
  return { isOpen, open, close };
};

// Loading screen selectors - using individual selectors to avoid object creation
export const useLoadingScreen = () => {
  const isVisible = useModalStore((state) => state.isLoadingScreenVisible);
  const setVisible = useModalStore((state) => state.setLoadingScreen);
  
  return { isVisible, setVisible };
};

// All modal state selector - using individual selectors to avoid object creation
export const useAllModals = () => {
  const isContactModalOpen = useModalStore((state) => state.isContactModalOpen);
  const isLoadingScreenVisible = useModalStore((state) => state.isLoadingScreenVisible);
  const openContactModal = useModalStore((state) => state.openContactModal);
  const closeContactModal = useModalStore((state) => state.closeContactModal);
  const setLoadingScreen = useModalStore((state) => state.setLoadingScreen);
  const closeAllModals = useModalStore((state) => state.closeAllModals);
  
  return {
    isContactModalOpen,
    isLoadingScreenVisible,
    openContactModal,
    closeContactModal,
    setLoadingScreen,
    closeAllModals,
  };
};
